import { useEffect } from "react"
import { Button } from "./Button"

const PUBLIC_KEY = "sc_pk_xysyu6qxz09d5ouWs73X"
const SCRIPT_SRC = "https://www.sharecount.app/embed.js"

declare global {
  interface Window {
    ShareCount?: {
      open: (publicKey?: string) => void
      close: () => void
    }
  }
}

// Load the embed script once per page. The SDK uses a MutationObserver to pick
// up mount nodes added later by SPA route changes, so we don't re-init on nav.
export function useShareCountScript() {
  useEffect(() => {
    if (typeof document === "undefined") return
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return
    const s = document.createElement("script")
    s.src = SCRIPT_SRC
    s.async = true
    document.head.appendChild(s)
  }, [])
}

function openDialog() {
  if (typeof window === "undefined") return
  if (window.ShareCount?.open) {
    window.ShareCount.open(PUBLIC_KEY)
    return
  }
  setTimeout(openDialog, 100)
}

export function ShareCountPromo({ className = "" }: { className?: string }) {
  return (
    <div
      data-testid="sharecount-promo"
      className={`mx-auto flex w-full max-w-3xl flex-col items-center gap-y-4 rounded-2xl bg-linear-to-br from-brand-50 via-white to-lime-50 p-6 text-center ring-1 ring-brand-200/70 sm:flex-row sm:gap-x-6 sm:p-7 sm:text-left ${className}`}
    >
      <div className="flex-1">
        <p className="font-display text-xl font-semibold tracking-tight text-balance text-ink-950 sm:text-2xl">
          Share CleanMyList and get up to 40% off your credits purchase!
        </p>
        <p className="mt-1.5 text-[0.6875rem] tracking-tight text-ink-400">
          Powered by{" "}
          <a
            href="https://www.sharecount.app"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 hover:text-ink-600"
          >
            ShareCount
          </a>
        </p>
      </div>
      <Button
        type="button"
        variant="brand"
        size="lg"
        onClick={openDialog}
        data-testid="sharecount-open-button"
        className="shrink-0"
      >
        Share & save
      </Button>
      <div data-sharecount={PUBLIC_KEY} className="hidden" aria-hidden="true" />
    </div>
  )
}
